/*eslint-disable */
import React from "react";
// import '../style/DashboardStyles.css';
import propTypes from "prop-types";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useNavigate } from "react-router-dom";
import { AvatarInitial } from "@utils/Logo";

const DashboardNavbar = ({ user }) => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const menuOpen = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const style = {
    display: "flex",
    flexDirection: "row",
    padding: "1.1rem",
  };
  return (
    <div className="dashboard-navbar" style={style}>
      <div className="right" style={{ alignItems: "center", display: "flex" }}>
        {/* <div className="notification-area mr-2">
          <div className="notification-dot"></div>
          <i className="fa fa-bell" aria-hidden="true"></i>
        </div> */}
        <AvatarInitial text={`${user?.first_name} ${user?.last_name}` || ""} />
        <IconButton
          aria-label="more"
          id="long-button"
          aria-controls={menuOpen ? "long-menu" : undefined}
          aria-expanded={menuOpen ? "true" : undefined}
          aria-haspopup="true"
          onClick={handleClick}
        >
          <MoreVertIcon />
        </IconButton>
        <Menu
          id="long-menu"
          MenuListProps={{
            "aria-labelledby": "long-button",
          }}
          anchorEl={anchorEl}
          open={menuOpen}
          onClose={handleClose}
          PaperProps={{
            style: {
              width: "20ch",
            },
          }}
        >
          <MenuItem key={1} onClick={handleClose}>
            Account Settings
          </MenuItem>
        </Menu>
      </div>
    </div>
  );
};

DashboardNavbar.propTypes = {
  user: propTypes.object,
};

export default DashboardNavbar;
